// removed by extract-text-webpack-plugin
module.exports = {"loader":"Button__loader__8TbHw","show":"Button__show__1yeaL"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Common/Button/Button.scss
// module id = 1744
// module chunks = 0